<template>
  <v-container fluid class="d-flex flex-column align-center d">
    <v-row>
      <v-col>
        <v-img
          contain
          height="29"
          src="@/assets/i4p_logo.png"
        ></v-img>
      </v-col>
    </v-row>

    <v-row>
      <v-container class="mt-16 d-flex flex-column align-items-center justif">
        <v-row align-self="center">
          <div class="display-1 mt-16 pt-10 ma-auto font-weight-bold">
            {{ currentMode.title }}
          </div>
        </v-row>
        <v-row>
          <div class="my-8 subtitle-2 grey--text">
            {{ currentMode.explainer }}
          </div>
        </v-row>
        <v-row align="center" justify="center">
          <v-btn
            id="permission_denied"
            color="primary"
            @click="currentMode.btnAction "
          >
            {{ currentMode.btnText }}
          </v-btn>
          <v-btn
            v-if="!!currentMode.secondaryBtnText"
            color="primary"
            outlined
            class="ml-3"
            @click="currentMode.secondaryBtnAction"
          >
            {{ currentMode.secondaryBtnText }}
          </v-btn>
        </v-row>
      </v-container>
    </v-row>

    <div>
      <v-img
        class="dead-doc-img"
        contain
        height="134px"

        src="@/assets/icons/permisson_denied.png"
      ></v-img>
    </div>
  </v-container>
</template>
<script>

export default {

  data() {
    return {

      suspendedMode: {
        title: this.$t('errorPage.suspendedMode.title'),
        explainer: this.$t('errorPage.suspendedMode.explainer'),
        btnText: this.$t('errorPage.suspendedMode.btnText'),
        btnAction: this.userSuspendedLogin

      },
      notAllowedMode: {
        title: this.$t('errorPage.notAllowed.title'),
        explainer: this.$t('errorPage.notAllowed.explainer'),
        btnText: this.$t('errorPage.notAllowed.btnText'),
        btnAction: this.userNotAllowedHereLogin,
        secondaryBtnText: this.$t('errorPage.notAllowed.secondaryBtnText'),
        secondaryBtnAction: this.backToDashboard
      },
      notFoundMode: {
        title: this.$t('errorPage.notFound.title'),
        explainer: this.$t('errorPage.notFound.explainer'),
        btnText: this.$t('errorPage.notFound.btnText'),
        btnAction: this.backToDashboard
      }
    }
  },
  computed: {
    currentMode() {
      const user = this.$store.state.currentUser
      // if (!user || user.status === 'SUSPENDED') {
      if (user && user.status === 'SUSPENDED') {
        return this.suspendedMode
      } else if (this.$route.name === 'NotFound') {
        return this.notFoundMode
      }
      return this.notAllowedMode
    }
  },
  methods: {
    userSuspendedLogin() {
      this.$auth.logout()
      this.$store.commit('removeCurrentUser')
    },
    backToDashboard() {
      if (this.currentMode.title === this.suspendedMode.title) {
        this.$auth.logout()
        this.$store.commit('removeCurrentUser')
        this.$router.push({ name: 'Welcome' })
        return
      }
      this.$router.push({ name: 'Dashboard' })
    },
    userNotAllowedHereLogin() {
      this.$auth.logout()
      this.$store.commit('removeCurrentUser')
      return this.$auth.login(this.prevRoute || 'Dashboard')
    }
  }
}
</script>

<style scoped>

.dead-doc-img {
position: fixed ;
left: calc(50vw - 69px);
/* margin: auto; */
/* width: 100%; */
bottom: -2vh;
transform: rotate(-3.31deg);
}
</style>
